import * as React from 'react';

export const amFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3142)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#2E42A5'
            />
            <mask
                id='mask0_55_3142'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3142)'>
                <path
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FECA00'
                />
                <path
                    d='M0 0H28V6.66667H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#E31D1C'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3142'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
